import request from "@/api/request";


// export function getClassifyList(query) {
//     return request({
//         url: '/video/node',
//         method: 'get',
//         params: query
//     })
// }

export function search(data) {
    return request({
        url: `/api/video/search`,
        method: 'post',
        data: data
    })
}

export function index(secret) {
    return request({
        url: '/api/video/index',
        method: 'get',
        headers: {
            'secret-key': secret
        }
    })
}

export function info(id) {
    return request({
        url: `/api/video/info/${id}`,
        method: 'get'
    })
}

export function send(params) {
    return request({
        url: '/api/video/send',
        method: 'post',
        data: params
    })
}


// export function getClassifyList(query) {
//     return request({
//         url: '/video/getClassifyList',
//         method: 'get',
//         params: query
//     })
// }
//
// export function init(query, params) {
//     return request({
//         url: `/video/${query}/init`,
//         method: 'get',
//         params: params
//     })
// }
//
// export function info(query, id) {
//     return request({
//         url: `/video/${query}/info/${id}`,
//         method: 'get'
//     })
// }
//
export function hotKey() {
    return request({
        url: '/api/video/hotKey',
        method: 'get'
    })
}

//

//
// export function play(query, params) {
//     return request({
//         url: `/video/${query}/play`,
//         method: 'post',
//         params: params
//     })
// }
